import { LuCalendarDays, LuUserRound } from 'react-icons/lu'
import { Link } from 'react-router'
import { ROUTES } from '@/constants/routes'
import { GrainOverlay } from '@/components/ui/GrainOverlay'
import { HeroCarousel } from '@/components/home/HeroCarousel'

export const HeroSection = () => (
  <section
    aria-labelledby="hero-heading"
    className="relative overflow-hidden bg-green-950 text-base-50"
  >
    <GrainOverlay opacity={0.025} />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-40 -top-40 h-[560px] w-[560px] rounded-full bg-green-800/20 blur-3xl"
    />

    <div className="relative z-10 mx-auto grid max-w-[88rem] gap-x-12 px-6 pb-10 pt-9 sm:px-10 sm:py-14 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:grid-rows-[1fr_auto_auto_auto_1fr] lg:gap-x-16 lg:px-12 lg:py-20 xl:gap-x-20">
      <div className="lg:col-start-1 lg:row-start-2">
        <h1
          id="hero-heading"
          className="font-display text-[clamp(2.5rem,8vw,3.6rem)] leading-[1.08] tracking-tight lg:text-[clamp(2.75rem,4vw,4.25rem)]"
        >
          Bridging Indigenous Wisdom{' '}
          <span className="mt-1 block text-gold-200">&amp; Modern Science</span>
        </h1>
      </div>

      <div className="mt-6 flex flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:gap-6 lg:col-start-1 lg:row-start-4 lg:mb-8 lg:mt-7 lg:flex-wrap">
        <Link
          to={ROUTES.SERVICES_CONSULTATIONS}
          className="inline-flex min-h-12 items-center justify-center gap-3 rounded-full bg-base-50 px-6 py-3.5 text-sm font-semibold text-green-950 transition-colors hover:bg-gold-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-200 focus-visible:ring-offset-4 focus-visible:ring-offset-green-950"
        >
          Explore Herbal Consultations
          <LuCalendarDays aria-hidden="true" className="h-4 w-4 shrink-0" />
        </Link>
        <Link
          to={ROUTES.ABOUT}
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-sm text-sm text-base-100 underline decoration-gold-200/50 underline-offset-8 transition-colors hover:text-gold-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-200"
        >
          About Kandake <LuUserRound aria-hidden="true" className="h-4 w-4 shrink-0" />
        </Link>
      </div>

      <HeroCarousel />

      <div className="lg:col-start-1 lg:row-start-3 lg:pt-6">
        <p className="max-w-md text-base leading-relaxed text-base-100 sm:text-lg">
          Health Consultations, Bio-Scans, Courses, Presentations and Herbal Products.
        </p>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-green-200">
          Rooted in African and Caribbean Traditions with modern Western clinical training.
        </p>

        <p className="mt-8 border-t border-white/15 pt-5 text-xs leading-relaxed text-green-200">
          BSc (Hons) Medical Herbalism
          <span aria-hidden="true" className="mx-2 text-gold-200">
            ·
          </span>
          30+ years of holistic health experience
        </p>
      </div>
    </div>
  </section>
)
